/*
 * Created on Wed Oct 11 2023 4:56:55 PM
 *
 * ***************************************************************************************
 * Copyright (c) AVPS Technologies Inc 2023 
 *
 * All Rights Reserved
 * Unpublished rights are reserved under the copyright laws of the United States.
 * The software contained in this media is proprietary to and embodies confidential
 * the technology of AVPS Technologies Inc. Possession, use, duplication or
 * dissemination of the software and media is authorized only pursuant to a valid
 * written license from AVPS Technologies Inc.
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * RESTRICTED RIGHTS LEGEND Use, duplication, or disclosure by the U.S. Government
 * is subject to restrictions as set forth in Subparagraph (c) (1) (ii) of DFARS
 * 252.227-7013 or in FAR 52.227-19, as applicable.
 ****************************************************************************************
 */

import { FaPhone, FaRegCommentDots } from 'react-icons/fa';

const SupportSection = ({
    companyDetails,
    onContactNavigate,
    getDomainTextColor,
    isFlexOfficeDomain,
    isRetailDomain,
    isEducationDomain,
    getDocumentTypeDisplay
}) => {
    if (!companyDetails?.contactPerson) return null;

    return (
        <div className="bg-white border border-slate-200 rounded-lg p-6">
            <div className="flex flex-col lg:flex-row lg:items-center justify-between gap-4">
                <div>
                    <h3 className="text-lg font-semibold text-slate-900 mb-1">
                        Need help with your {isFlexOfficeDomain ? 'reservation' :
                            isRetailDomain ? 'order' :
                                isEducationDomain ? 'enrollment' :
                                    getDocumentTypeDisplay().toLowerCase()}?
                    </h3>
                    <p className="text-slate-600 mb-4 lg:mb-0">
                        {isFlexOfficeDomain
                            ? 'Our support team is here to help you with changes, cancellations, or questions.'
                            : isRetailDomain
                                ? 'Our support team is here to help you with order changes, cancellations, or questions.'
                                : isEducationDomain
                                    ? 'Our support team is here to help you with enrollment changes, cancellations, or questions.'
                                    : 'Our support team is here to help you'
                        }
                    </p>
                </div>
                <div className="flex flex-wrap gap-3">
                    {companyDetails?.contactPerson?.email && (
                        <button
                            type="button"
                            onClick={onContactNavigate}
                            className="px-5 py-3 lg:py-2.5 text-white rounded-lg hover:opacity-90 transition-colors font-medium flex items-center gap-2"
                            style={{ backgroundColor: getDomainTextColor() }}
                        >
                            <FaRegCommentDots className="w-4 h-4" />
                            Get in Touch
                        </button>
                    )}

                    {companyDetails?.contactPerson?.phoneNumber && (
                        <a
                            href={`tel:${companyDetails.contactPerson.phoneNumber}`}
                            className="px-5 py-3 lg:py-2.5 bg-white border border-slate-300 text-slate-700 rounded-lg hover:bg-slate-50 transition-colors font-medium flex items-center gap-2"
                            style={{ borderColor: getDomainTextColor() + '50', color: getDomainTextColor() }}
                        >
                            <FaPhone className="w-4 h-4" />
                            {isFlexOfficeDomain ? 'Call Support' :
                                isRetailDomain ? 'Call Support' :
                                    isEducationDomain ? 'Call Support' : 'Call'}
                        </a>
                    )}
                </div>
            </div>
        </div>
    );
};

export default SupportSection;